import React from "react";
import * as THREE from "three";

const MastColumnBeam = ({ column, colorList, luminaires, gridScaleX, gridScaleY }) => {
    const { height = 6, point } = column.values;
    const { x, y } = point;
    const radius = 0.2;
    const defaultBaseColor = "orange";
    const safeScaleX = gridScaleX || 1;
    const safeScaleY = gridScaleY || 1;
    const columnBaseZ = -height / 2;
    const renderX = x / safeScaleX;
    const renderY = (y * -1) / safeScaleY;
    const { lanterns = [] } = column.values;

    const topOfColumn = new THREE.Vector3(
        renderX,
        renderY,
        columnBaseZ - height / 2 + 0.05
    );
    const normalize360 = (angle) => ((Number(angle) % 360) + 360) % 360;
    const defaultOutreach = column.values?.outreach || 0.75;
    const fallbackBeamLength = Math.max(0.75, 0.75 * defaultOutreach);

    return (
        <>
            <mesh
                position={[renderX, renderY, columnBaseZ]}
                rotation={[Math.PI / 2, 0, 0]}
            >
                <cylinderGeometry
                    args={[radius, radius, height, 32]}
                />
                <meshStandardMaterial color={defaultBaseColor} />
            </mesh>

            {lanterns.map((lantern, index) => {
                const { beamAimingInfo } = lantern;
                // Derive beam endpoint from current mast position + angle + length so beams move with dragged masts.
                // In beam/asym modes lantern.positionAngle is already absolute in world space (same as 2D).
                const angle = normalize360(lantern?.positionAngle ?? 0);
                // Match 2D beam convention: tip uses (positionAngle - 90).
                const angleRad = (angle - 90) * (Math.PI / 180);
                const direction = new THREE.Vector3(Math.cos(angleRad), -Math.sin(angleRad), 0);

                const storedLength = Number(beamAimingInfo?.beamLength);
                const beamLength = Number.isFinite(storedLength) && storedLength > 0
                    ? storedLength
                    : fallbackBeamLength;

                const beamEnd = new THREE.Vector3(
                    topOfColumn.x + (direction.x * beamLength) / safeScaleX,
                    topOfColumn.y + (direction.y * beamLength) / safeScaleY,
                    0
                );

                const points = [topOfColumn, beamEnd];
                const geometry = new THREE.BufferGeometry().setFromPoints(points);

                const luminaireIndex = luminaires.indexOf(lantern.luminaireId);
                const resolvedColor =
                    luminaireIndex !== -1 && colorList[luminaireIndex]
                        ? colorList[luminaireIndex]
                        : defaultBaseColor;

                return (
                    <line key={index} geometry={geometry}>
                        <lineBasicMaterial
                            color={resolvedColor === "#FFA500 " ? defaultBaseColor : resolvedColor}
                            linewidth={2}
                        />
                    </line>
                );
            })}
        </>
    );
};

export default MastColumnBeam;
